import MUIDialog from '@mui/material/Dialog'

export const Dialog = MUIDialog
